import ShippingElement from './shipping_element';

export type { ShippingElementJson } from './shipping_element';

export default ShippingElement;
